// extracted by mini-css-extract-plugin
export default {"container":"qrpage_container__B-97t","title":"qrpage_title__Qfh4l","description":"qrpage_description__UKGHF","bottombar":"qrpage_bottombar__8sKrG"};